import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubmitComponent } from './submit.component';
import { SubmitDealResolver } from './submit-resolver.service';
import { AuthGuard } from '../core';
import { SharedModule } from '../shared';

const routes: Routes = [
    {
        path: '',
        component: SubmitComponent,
        canActivate: [AuthGuard]
    },
    {
        path: ':slug',
        component: SubmitComponent,
        canActivate: [AuthGuard],
        resolve: {
            deal: SubmitDealResolver
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SubmitRoutingModule {}
